import { Dialog, useMediaQuery, useTheme, type DialogProps } from '@mui/material';

/**
 * A dialog that opens full screen on a phone when it holds a form or a table (maxWidth sm and up), so nothing is
 * squeezed; a small confirmation (maxWidth xs) stays a floating box. On a tablet or desktop it is an ordinary dialog.
 */
export default function ResponsiveDialog(props: DialogProps) {
  const theme = useTheme();
  const phone = useMediaQuery(theme.breakpoints.down('sm'));
  const big = props.maxWidth !== 'xs' && props.maxWidth !== false;
  return <Dialog fullScreen={phone && big} {...props} />;
}
